import mock from './mock';

//import './data/ecommerce';

mock.onAny().passThrough();
